/**
 * BottomNav — the shell's tab bar (§7.2). It only reports which tab was tapped;
 * the shell decides what a tab change also clears. The Advanced tab shows only
 * when `showAdvanced` is set.
 */

// `feedback` is still a TabId (the gear menu mounts FeedbackTab as the
// `feedback` view) — it is just no longer a top-level nav tab (§7.9).
export type TabId = "capture" | "log" | "decisions" | "master" | "reports" | "feedback" | "advanced";

// §7.2: a 3×2 grid of SIX tabs. Labels only change (TabId values + `nav-tab-*`
// testids are preserved); the design's short corner labels are used verbatim
// from the preview. Feedback + Install move behind the settings gear (§7.9).
const TABS: Array<{ id: TabId; label: string; built: boolean }> = [
  { id: "capture", label: "Record", built: true }, // CaptureHome, SK-HOME, T-01
  { id: "log", label: "Daily Logs", built: true }, // DailyLog, SK-LOG, T-17
  { id: "decisions", label: "Decisions", built: true }, // DecisionLogView, SK-DECISIONS, T-18
  { id: "master", label: "Action List", built: true }, // MasterActionListView, SK-MASTER, T-19
  { id: "reports", label: "Reports", built: true }, // ReportsView, SK-REPORTS, T-22
  { id: "advanced", label: "Advanced", built: true }, // AdvancedModeGate, SK-ADV, T-24
];

export interface BottomNavProps {
  tab: TabId;
  showAdvanced: boolean;
  onSelect: (id: TabId) => void;
}

export function BottomNav({ tab, showAdvanced, onSelect }: BottomNavProps) {
  return (
    <nav data-testid="app-nav">
      {TABS.filter((t) => t.id !== "advanced" || showAdvanced).map((t) => (
        <button
          key={t.id}
          type="button"
          data-testid={`nav-tab-${t.id}`}
          aria-current={tab === t.id ? "page" : undefined}
          onClick={() => onSelect(t.id)}
        >
          {t.label}
        </button>
      ))}
    </nav>
  );
}
